module.exports = __webpack_public_path__ + "media/images/emblems/Heiligenschwendi-coat_of_arms-d6e2426781a8ceeefa5ec0c7f42e1c32.svg";